module.exports = __webpack_public_path__ + "img/42_7.b60e39f8.png";